import { ref, isRef, Ref } from 'vue'
import { useCommand } from '@cqrs/vue-composables-cqrs'
import * as c from './commands-core'

export function useClearPhasesCommandV1(
	userId?: number | Ref<number> | (() => number), 
	workspaceId?: number | Ref<number> | (() => number), 
	portfolioId?: string | Ref<string> | (() => string), 
	projectId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
) 
{
	const _userId = isRef<number>(userId) ? userId : ref<number>((typeof userId === 'function') ? userId() : userId)
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _portfolioId = isRef<string>(portfolioId) ? portfolioId : ref<string>((typeof portfolioId === 'function') ? portfolioId() : portfolioId)
	const _projectId = isRef<string>(projectId) ? projectId : ref<string>((typeof projectId === 'function') ? projectId() : projectId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)

	const result = {
		userId: _userId,
		workspaceId: _workspaceId,
		portfolioId: _portfolioId,
		projectId: _projectId,
		id: _id,

		...useCommand(() => {
			if (typeof userId === 'function') { _userId.value = userId() }
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof portfolioId === 'function') { _portfolioId.value = portfolioId() }
			if (typeof projectId === 'function') { _projectId.value = projectId() }
			if (typeof id === 'function') { _id.value = id() }

			return new c.ClearPhasesCommandV1(_userId.value, _workspaceId.value, _portfolioId.value, _projectId.value, _id.value)
		})
	}

	return {
		...result,
		authorizedClearPhasesCommandV1: result.authorized,
		clearPhasesCommandV1: result.command,
		completedClearPhasesCommandV1: result.completed,
		errorClearPhasesCommandV1: result.error,
		invokeClearPhasesCommandV1: result.invoke,
		invokingClearPhasesCommandV1: result.invoking,
		succeedClearPhasesCommandV1: result.succeed,
		validationErrorsClearPhasesCommandV1: result.validationErrors,
		onSucceedClearPhasesCommandV1: result.onSucceed,
	}
}

export function useCloneProjectPlanCommandV1(
	userId?: number | Ref<number> | (() => number), 
	workspaceId?: number | Ref<number> | (() => number), 
	portfolioId?: string | Ref<string> | (() => string), 
	projectId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	sourcePlanId?: string | Ref<string> | (() => string), 
	clonePlanName?: string | Ref<string> | (() => string), 
) 
{
	const _userId = isRef<number>(userId) ? userId : ref<number>((typeof userId === 'function') ? userId() : userId)
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _portfolioId = isRef<string>(portfolioId) ? portfolioId : ref<string>((typeof portfolioId === 'function') ? portfolioId() : portfolioId)
	const _projectId = isRef<string>(projectId) ? projectId : ref<string>((typeof projectId === 'function') ? projectId() : projectId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _sourcePlanId = isRef<string>(sourcePlanId) ? sourcePlanId : ref<string>((typeof sourcePlanId === 'function') ? sourcePlanId() : sourcePlanId)
	const _clonePlanName = isRef<string>(clonePlanName) ? clonePlanName : ref<string>((typeof clonePlanName === 'function') ? clonePlanName() : clonePlanName)

	const result = {
		userId: _userId,
		workspaceId: _workspaceId,
		portfolioId: _portfolioId,
		projectId: _projectId,
		id: _id,
		sourcePlanId: _sourcePlanId,
		clonePlanName: _clonePlanName,

		...useCommand(() => {
			if (typeof userId === 'function') { _userId.value = userId() }
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof portfolioId === 'function') { _portfolioId.value = portfolioId() }
			if (typeof projectId === 'function') { _projectId.value = projectId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof sourcePlanId === 'function') { _sourcePlanId.value = sourcePlanId() }
			if (typeof clonePlanName === 'function') { _clonePlanName.value = clonePlanName() }

			return new c.CloneProjectPlanCommandV1(_userId.value, _workspaceId.value, _portfolioId.value, _projectId.value, _id.value, _sourcePlanId.value, _clonePlanName.value)
		})
	}

	return {
		...result,
		authorizedCloneProjectPlanCommandV1: result.authorized,
		cloneProjectPlanCommandV1: result.command,
		completedCloneProjectPlanCommandV1: result.completed,
		errorCloneProjectPlanCommandV1: result.error,
		invokeCloneProjectPlanCommandV1: result.invoke,
		invokingCloneProjectPlanCommandV1: result.invoking,
		succeedCloneProjectPlanCommandV1: result.succeed,
		validationErrorsCloneProjectPlanCommandV1: result.validationErrors,
		onSucceedCloneProjectPlanCommandV1: result.onSucceed,
	}
}

export function useCreateProjectPlanCommandV1(
	userId?: number | Ref<number> | (() => number), 
	workspaceId?: number | Ref<number> | (() => number), 
	portfolioId?: string | Ref<string> | (() => string), 
	projectId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	planName?: string | Ref<string> | (() => string), 
	durationInMonths?: number | Ref<number> | (() => number), 
	granularity?: any | Ref<any> | (() => any), 
	denomination?: any | Ref<any> | (() => any), 
	submissionDueDateIsoString?: string | Ref<string> | (() => string), 
) 
{
	const _userId = isRef<number>(userId) ? userId : ref<number>((typeof userId === 'function') ? userId() : userId)
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _portfolioId = isRef<string>(portfolioId) ? portfolioId : ref<string>((typeof portfolioId === 'function') ? portfolioId() : portfolioId)
	const _projectId = isRef<string>(projectId) ? projectId : ref<string>((typeof projectId === 'function') ? projectId() : projectId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _planName = isRef<string>(planName) ? planName : ref<string>((typeof planName === 'function') ? planName() : planName)
	const _durationInMonths = isRef<number>(durationInMonths) ? durationInMonths : ref<number>((typeof durationInMonths === 'function') ? durationInMonths() : durationInMonths)
	const _granularity = isRef<any>(granularity) ? granularity : ref<any>((typeof granularity === 'function') ? granularity() : granularity)
	const _denomination = isRef<any>(denomination) ? denomination : ref<any>((typeof denomination === 'function') ? denomination() : denomination)
	const _submissionDueDateIsoString = isRef<string>(submissionDueDateIsoString) ? submissionDueDateIsoString : ref<string>((typeof submissionDueDateIsoString === 'function') ? submissionDueDateIsoString() : submissionDueDateIsoString)

	const result = {
		userId: _userId,
		workspaceId: _workspaceId,
		portfolioId: _portfolioId,
		projectId: _projectId,
		id: _id,
		planName: _planName,
		durationInMonths: _durationInMonths,
		granularity: _granularity,
		denomination: _denomination,
		submissionDueDateIsoString: _submissionDueDateIsoString,

		...useCommand(() => {
			if (typeof userId === 'function') { _userId.value = userId() }
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof portfolioId === 'function') { _portfolioId.value = portfolioId() }
			if (typeof projectId === 'function') { _projectId.value = projectId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof planName === 'function') { _planName.value = planName() }
			if (typeof durationInMonths === 'function') { _durationInMonths.value = durationInMonths() }
			if (typeof granularity === 'function') { _granularity.value = granularity() }
			if (typeof denomination === 'function') { _denomination.value = denomination() }
			if (typeof submissionDueDateIsoString === 'function') { _submissionDueDateIsoString.value = submissionDueDateIsoString() }

			return new c.CreateProjectPlanCommandV1(_userId.value, _workspaceId.value, _portfolioId.value, _projectId.value, _id.value, _planName.value, _durationInMonths.value, _granularity.value, _denomination.value, _submissionDueDateIsoString.value)
		})
	}

	return {
		...result,
		authorizedCreateProjectPlanCommandV1: result.authorized,
		createProjectPlanCommandV1: result.command,
		completedCreateProjectPlanCommandV1: result.completed,
		errorCreateProjectPlanCommandV1: result.error,
		invokeCreateProjectPlanCommandV1: result.invoke,
		invokingCreateProjectPlanCommandV1: result.invoking,
		succeedCreateProjectPlanCommandV1: result.succeed,
		validationErrorsCreateProjectPlanCommandV1: result.validationErrors,
		onSucceedCreateProjectPlanCommandV1: result.onSucceed,
	}
}

export function useCreateProjectCapexItemCommandV1(
	userId?: number | Ref<number> | (() => number), 
	workspaceId?: number | Ref<number> | (() => number), 
	portfolioId?: string | Ref<string> | (() => string), 
	projectId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	itemId?: string | Ref<string> | (() => string), 
	capexAccountId?: string | Ref<string> | (() => string), 
	name?: string | Ref<string> | (() => string), 
	cost?: number | Ref<number> | (() => number), 
	acquisitionMonthIndex?: number | Ref<number> | (() => number), 
	salvageValue?: number | null | Ref<number | null> | (() => number | null), 
	usefulLifeInYears?: number | null | Ref<number | null> | (() => number | null), 
	depreciationMethod?: any | Ref<any> | (() => any), 
	denomination?: any | Ref<any> | (() => any), 
) 
{
	const _userId = isRef<number>(userId) ? userId : ref<number>((typeof userId === 'function') ? userId() : userId)
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _portfolioId = isRef<string>(portfolioId) ? portfolioId : ref<string>((typeof portfolioId === 'function') ? portfolioId() : portfolioId)
	const _projectId = isRef<string>(projectId) ? projectId : ref<string>((typeof projectId === 'function') ? projectId() : projectId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _itemId = isRef<string>(itemId) ? itemId : ref<string>((typeof itemId === 'function') ? itemId() : itemId)
	const _capexAccountId = isRef<string>(capexAccountId) ? capexAccountId : ref<string>((typeof capexAccountId === 'function') ? capexAccountId() : capexAccountId)
	const _name = isRef<string>(name) ? name : ref<string>((typeof name === 'function') ? name() : name)
	const _cost = isRef<number>(cost) ? cost : ref<number>((typeof cost === 'function') ? cost() : cost)
	const _acquisitionMonthIndex = isRef<number>(acquisitionMonthIndex) ? acquisitionMonthIndex : ref<number>((typeof acquisitionMonthIndex === 'function') ? acquisitionMonthIndex() : acquisitionMonthIndex)
	const _salvageValue = isRef<number | null>(salvageValue) ? salvageValue : ref<number | null>((typeof salvageValue === 'function') ? salvageValue() : salvageValue)
	const _usefulLifeInYears = isRef<number | null>(usefulLifeInYears) ? usefulLifeInYears : ref<number | null>((typeof usefulLifeInYears === 'function') ? usefulLifeInYears() : usefulLifeInYears)
	const _depreciationMethod = isRef<any>(depreciationMethod) ? depreciationMethod : ref<any>((typeof depreciationMethod === 'function') ? depreciationMethod() : depreciationMethod)
	const _denomination = isRef<any>(denomination) ? denomination : ref<any>((typeof denomination === 'function') ? denomination() : denomination)

	const result = {
		userId: _userId,
		workspaceId: _workspaceId,
		portfolioId: _portfolioId,
		projectId: _projectId,
		id: _id,
		itemId: _itemId,
		capexAccountId: _capexAccountId,
		name: _name,
		cost: _cost,
		acquisitionMonthIndex: _acquisitionMonthIndex,
		salvageValue: _salvageValue,
		usefulLifeInYears: _usefulLifeInYears,
		depreciationMethod: _depreciationMethod,
		denomination: _denomination,

		...useCommand(() => {
			if (typeof userId === 'function') { _userId.value = userId() }
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof portfolioId === 'function') { _portfolioId.value = portfolioId() }
			if (typeof projectId === 'function') { _projectId.value = projectId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof itemId === 'function') { _itemId.value = itemId() }
			if (typeof capexAccountId === 'function') { _capexAccountId.value = capexAccountId() }
			if (typeof name === 'function') { _name.value = name() }
			if (typeof cost === 'function') { _cost.value = cost() }
			if (typeof acquisitionMonthIndex === 'function') { _acquisitionMonthIndex.value = acquisitionMonthIndex() }
			if (typeof salvageValue === 'function') { _salvageValue.value = salvageValue() }
			if (typeof usefulLifeInYears === 'function') { _usefulLifeInYears.value = usefulLifeInYears() }
			if (typeof depreciationMethod === 'function') { _depreciationMethod.value = depreciationMethod() }
			if (typeof denomination === 'function') { _denomination.value = denomination() }

			return new c.CreateProjectCapexItemCommandV1(_userId.value, _workspaceId.value, _portfolioId.value, _projectId.value, _id.value, _itemId.value, _capexAccountId.value, _name.value, _cost.value, _acquisitionMonthIndex.value, _salvageValue.value, _usefulLifeInYears.value, _depreciationMethod.value, _denomination.value)
		})
	}

	return {
		...result,
		authorizedCreateProjectCapexItemCommandV1: result.authorized,
		createProjectCapexItemCommandV1: result.command,
		completedCreateProjectCapexItemCommandV1: result.completed,
		errorCreateProjectCapexItemCommandV1: result.error,
		invokeCreateProjectCapexItemCommandV1: result.invoke,
		invokingCreateProjectCapexItemCommandV1: result.invoking,
		succeedCreateProjectCapexItemCommandV1: result.succeed,
		validationErrorsCreateProjectCapexItemCommandV1: result.validationErrors,
		onSucceedCreateProjectCapexItemCommandV1: result.onSucceed,
	}
}

export function useCreatePlanFromTemplateCommandV1(
	userId?: number | Ref<number> | (() => number), 
	workspaceId?: number | Ref<number> | (() => number), 
	portfolioId?: string | Ref<string> | (() => string), 
	projectId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	planName?: string | Ref<string> | (() => string), 
	projectPlanTemplateId?: string | Ref<string> | (() => string), 
) 
{
	const _userId = isRef<number>(userId) ? userId : ref<number>((typeof userId === 'function') ? userId() : userId)
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _portfolioId = isRef<string>(portfolioId) ? portfolioId : ref<string>((typeof portfolioId === 'function') ? portfolioId() : portfolioId)
	const _projectId = isRef<string>(projectId) ? projectId : ref<string>((typeof projectId === 'function') ? projectId() : projectId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _planName = isRef<string>(planName) ? planName : ref<string>((typeof planName === 'function') ? planName() : planName)
	const _projectPlanTemplateId = isRef<string>(projectPlanTemplateId) ? projectPlanTemplateId : ref<string>((typeof projectPlanTemplateId === 'function') ? projectPlanTemplateId() : projectPlanTemplateId)

	const result = {
		userId: _userId,
		workspaceId: _workspaceId,
		portfolioId: _portfolioId,
		projectId: _projectId,
		id: _id,
		planName: _planName,
		projectPlanTemplateId: _projectPlanTemplateId,

		...useCommand(() => {
			if (typeof userId === 'function') { _userId.value = userId() }
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof portfolioId === 'function') { _portfolioId.value = portfolioId() }
			if (typeof projectId === 'function') { _projectId.value = projectId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof planName === 'function') { _planName.value = planName() }
			if (typeof projectPlanTemplateId === 'function') { _projectPlanTemplateId.value = projectPlanTemplateId() }

			return new c.CreatePlanFromTemplateCommandV1(_userId.value, _workspaceId.value, _portfolioId.value, _projectId.value, _id.value, _planName.value, _projectPlanTemplateId.value)
		})
	}

	return {
		...result,
		authorizedCreatePlanFromTemplateCommandV1: result.authorized,
		createPlanFromTemplateCommandV1: result.command,
		completedCreatePlanFromTemplateCommandV1: result.completed,
		errorCreatePlanFromTemplateCommandV1: result.error,
		invokeCreatePlanFromTemplateCommandV1: result.invoke,
		invokingCreatePlanFromTemplateCommandV1: result.invoking,
		succeedCreatePlanFromTemplateCommandV1: result.succeed,
		validationErrorsCreatePlanFromTemplateCommandV1: result.validationErrors,
		onSucceedCreatePlanFromTemplateCommandV1: result.onSucceed,
	}
}

export function useDeleteProjectCapexItemCommandV1(
	userId?: number | Ref<number> | (() => number), 
	workspaceId?: number | Ref<number> | (() => number), 
	portfolioId?: string | Ref<string> | (() => string), 
	projectId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	itemId?: string | Ref<string> | (() => string), 
) 
{
	const _userId = isRef<number>(userId) ? userId : ref<number>((typeof userId === 'function') ? userId() : userId)
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _portfolioId = isRef<string>(portfolioId) ? portfolioId : ref<string>((typeof portfolioId === 'function') ? portfolioId() : portfolioId)
	const _projectId = isRef<string>(projectId) ? projectId : ref<string>((typeof projectId === 'function') ? projectId() : projectId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _itemId = isRef<string>(itemId) ? itemId : ref<string>((typeof itemId === 'function') ? itemId() : itemId)

	const result = {
		userId: _userId,
		workspaceId: _workspaceId,
		portfolioId: _portfolioId,
		projectId: _projectId,
		id: _id,
		itemId: _itemId,

		...useCommand(() => {
			if (typeof userId === 'function') { _userId.value = userId() }
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof portfolioId === 'function') { _portfolioId.value = portfolioId() }
			if (typeof projectId === 'function') { _projectId.value = projectId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof itemId === 'function') { _itemId.value = itemId() }

			return new c.DeleteProjectCapexItemCommandV1(_userId.value, _workspaceId.value, _portfolioId.value, _projectId.value, _id.value, _itemId.value)
		})
	}

	return {
		...result,
		authorizedDeleteProjectCapexItemCommandV1: result.authorized,
		deleteProjectCapexItemCommandV1: result.command,
		completedDeleteProjectCapexItemCommandV1: result.completed,
		errorDeleteProjectCapexItemCommandV1: result.error,
		invokeDeleteProjectCapexItemCommandV1: result.invoke,
		invokingDeleteProjectCapexItemCommandV1: result.invoking,
		succeedDeleteProjectCapexItemCommandV1: result.succeed,
		validationErrorsDeleteProjectCapexItemCommandV1: result.validationErrors,
		onSucceedDeleteProjectCapexItemCommandV1: result.onSucceed,
	}
}

export function useDeleteProjectPlanCommandV1(
	userId?: number | Ref<number> | (() => number), 
	workspaceId?: number | Ref<number> | (() => number), 
	portfolioId?: string | Ref<string> | (() => string), 
	projectId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
) 
{
	const _userId = isRef<number>(userId) ? userId : ref<number>((typeof userId === 'function') ? userId() : userId)
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _portfolioId = isRef<string>(portfolioId) ? portfolioId : ref<string>((typeof portfolioId === 'function') ? portfolioId() : portfolioId)
	const _projectId = isRef<string>(projectId) ? projectId : ref<string>((typeof projectId === 'function') ? projectId() : projectId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)

	const result = {
		userId: _userId,
		workspaceId: _workspaceId,
		portfolioId: _portfolioId,
		projectId: _projectId,
		id: _id,

		...useCommand(() => {
			if (typeof userId === 'function') { _userId.value = userId() }
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof portfolioId === 'function') { _portfolioId.value = portfolioId() }
			if (typeof projectId === 'function') { _projectId.value = projectId() }
			if (typeof id === 'function') { _id.value = id() }

			return new c.DeleteProjectPlanCommandV1(_userId.value, _workspaceId.value, _portfolioId.value, _projectId.value, _id.value)
		})
	}

	return {
		...result,
		authorizedDeleteProjectPlanCommandV1: result.authorized,
		deleteProjectPlanCommandV1: result.command,
		completedDeleteProjectPlanCommandV1: result.completed,
		errorDeleteProjectPlanCommandV1: result.error,
		invokeDeleteProjectPlanCommandV1: result.invoke,
		invokingDeleteProjectPlanCommandV1: result.invoking,
		succeedDeleteProjectPlanCommandV1: result.succeed,
		validationErrorsDeleteProjectPlanCommandV1: result.validationErrors,
		onSucceedDeleteProjectPlanCommandV1: result.onSucceed,
	}
}

export function useExportProjectPlanCommandV1(
	userId?: number | Ref<number> | (() => number), 
	workspaceId?: number | Ref<number> | (() => number), 
	portfolioId?: string | Ref<string> | (() => string), 
	projectId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
) 
{
	const _userId = isRef<number>(userId) ? userId : ref<number>((typeof userId === 'function') ? userId() : userId)
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _portfolioId = isRef<string>(portfolioId) ? portfolioId : ref<string>((typeof portfolioId === 'function') ? portfolioId() : portfolioId)
	const _projectId = isRef<string>(projectId) ? projectId : ref<string>((typeof projectId === 'function') ? projectId() : projectId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)

	const result = {
		userId: _userId,
		workspaceId: _workspaceId,
		portfolioId: _portfolioId,
		projectId: _projectId,
		id: _id,

		...useCommand(() => {
			if (typeof userId === 'function') { _userId.value = userId() }
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof portfolioId === 'function') { _portfolioId.value = portfolioId() }
			if (typeof projectId === 'function') { _projectId.value = projectId() }
			if (typeof id === 'function') { _id.value = id() }

			return new c.ExportProjectPlanCommandV1(_userId.value, _workspaceId.value, _portfolioId.value, _projectId.value, _id.value)
		})
	}

	return {
		...result,
		authorizedExportProjectPlanCommandV1: result.authorized,
		exportProjectPlanCommandV1: result.command,
		completedExportProjectPlanCommandV1: result.completed,
		errorExportProjectPlanCommandV1: result.error,
		invokeExportProjectPlanCommandV1: result.invoke,
		invokingExportProjectPlanCommandV1: result.invoking,
		succeedExportProjectPlanCommandV1: result.succeed,
		validationErrorsExportProjectPlanCommandV1: result.validationErrors,
		onSucceedExportProjectPlanCommandV1: result.onSucceed,
	}
}

export function useSetPhaseDurationCommandV1(
	userId?: number | Ref<number> | (() => number), 
	workspaceId?: number | Ref<number> | (() => number), 
	portfolioId?: string | Ref<string> | (() => string), 
	projectId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	projectPhaseDefinitionId?: string | Ref<string> | (() => string), 
	durationInMonths?: number | Ref<number> | (() => number), 
) 
{
	const _userId = isRef<number>(userId) ? userId : ref<number>((typeof userId === 'function') ? userId() : userId)
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _portfolioId = isRef<string>(portfolioId) ? portfolioId : ref<string>((typeof portfolioId === 'function') ? portfolioId() : portfolioId)
	const _projectId = isRef<string>(projectId) ? projectId : ref<string>((typeof projectId === 'function') ? projectId() : projectId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _projectPhaseDefinitionId = isRef<string>(projectPhaseDefinitionId) ? projectPhaseDefinitionId : ref<string>((typeof projectPhaseDefinitionId === 'function') ? projectPhaseDefinitionId() : projectPhaseDefinitionId)
	const _durationInMonths = isRef<number>(durationInMonths) ? durationInMonths : ref<number>((typeof durationInMonths === 'function') ? durationInMonths() : durationInMonths)

	const result = {
		userId: _userId,
		workspaceId: _workspaceId,
		portfolioId: _portfolioId,
		projectId: _projectId,
		id: _id,
		projectPhaseDefinitionId: _projectPhaseDefinitionId,
		durationInMonths: _durationInMonths,

		...useCommand(() => {
			if (typeof userId === 'function') { _userId.value = userId() }
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof portfolioId === 'function') { _portfolioId.value = portfolioId() }
			if (typeof projectId === 'function') { _projectId.value = projectId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof projectPhaseDefinitionId === 'function') { _projectPhaseDefinitionId.value = projectPhaseDefinitionId() }
			if (typeof durationInMonths === 'function') { _durationInMonths.value = durationInMonths() }

			return new c.SetPhaseDurationCommandV1(_userId.value, _workspaceId.value, _portfolioId.value, _projectId.value, _id.value, _projectPhaseDefinitionId.value, _durationInMonths.value)
		})
	}

	return {
		...result,
		authorizedSetPhaseDurationCommandV1: result.authorized,
		setPhaseDurationCommandV1: result.command,
		completedSetPhaseDurationCommandV1: result.completed,
		errorSetPhaseDurationCommandV1: result.error,
		invokeSetPhaseDurationCommandV1: result.invoke,
		invokingSetPhaseDurationCommandV1: result.invoking,
		succeedSetPhaseDurationCommandV1: result.succeed,
		validationErrorsSetPhaseDurationCommandV1: result.validationErrors,
		onSucceedSetPhaseDurationCommandV1: result.onSucceed,
	}
}

export function useSetupPhasesCommandV1(
	userId?: number | Ref<number> | (() => number), 
	workspaceId?: number | Ref<number> | (() => number), 
	portfolioId?: string | Ref<string> | (() => string), 
	projectId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	phaseDurations?: any | Ref<any> | (() => any), 
) 
{
	const _userId = isRef<number>(userId) ? userId : ref<number>((typeof userId === 'function') ? userId() : userId)
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _portfolioId = isRef<string>(portfolioId) ? portfolioId : ref<string>((typeof portfolioId === 'function') ? portfolioId() : portfolioId)
	const _projectId = isRef<string>(projectId) ? projectId : ref<string>((typeof projectId === 'function') ? projectId() : projectId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _phaseDurations = isRef<any>(phaseDurations) ? phaseDurations : ref<any>((typeof phaseDurations === 'function') ? phaseDurations() : phaseDurations)

	const result = {
		userId: _userId,
		workspaceId: _workspaceId,
		portfolioId: _portfolioId,
		projectId: _projectId,
		id: _id,
		phaseDurations: _phaseDurations,

		...useCommand(() => {
			if (typeof userId === 'function') { _userId.value = userId() }
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof portfolioId === 'function') { _portfolioId.value = portfolioId() }
			if (typeof projectId === 'function') { _projectId.value = projectId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof phaseDurations === 'function') { _phaseDurations.value = phaseDurations() }

			return new c.SetupPhasesCommandV1(_userId.value, _workspaceId.value, _portfolioId.value, _projectId.value, _id.value, _phaseDurations.value)
		})
	}

	return {
		...result,
		authorizedSetupPhasesCommandV1: result.authorized,
		setupPhasesCommandV1: result.command,
		completedSetupPhasesCommandV1: result.completed,
		errorSetupPhasesCommandV1: result.error,
		invokeSetupPhasesCommandV1: result.invoke,
		invokingSetupPhasesCommandV1: result.invoking,
		succeedSetupPhasesCommandV1: result.succeed,
		validationErrorsSetupPhasesCommandV1: result.validationErrors,
		onSucceedSetupPhasesCommandV1: result.onSucceed,
	}
}

export function useSubmitProjectPlanCommandV1(
	userId?: number | Ref<number> | (() => number), 
	workspaceId?: number | Ref<number> | (() => number), 
	portfolioId?: string | Ref<string> | (() => string), 
	projectId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
) 
{
	const _userId = isRef<number>(userId) ? userId : ref<number>((typeof userId === 'function') ? userId() : userId)
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _portfolioId = isRef<string>(portfolioId) ? portfolioId : ref<string>((typeof portfolioId === 'function') ? portfolioId() : portfolioId)
	const _projectId = isRef<string>(projectId) ? projectId : ref<string>((typeof projectId === 'function') ? projectId() : projectId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)

	const result = {
		userId: _userId,
		workspaceId: _workspaceId,
		portfolioId: _portfolioId,
		projectId: _projectId,
		id: _id,

		...useCommand(() => {
			if (typeof userId === 'function') { _userId.value = userId() }
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof portfolioId === 'function') { _portfolioId.value = portfolioId() }
			if (typeof projectId === 'function') { _projectId.value = projectId() }
			if (typeof id === 'function') { _id.value = id() }

			return new c.SubmitProjectPlanCommandV1(_userId.value, _workspaceId.value, _portfolioId.value, _projectId.value, _id.value)
		})
	}

	return {
		...result,
		authorizedSubmitProjectPlanCommandV1: result.authorized,
		submitProjectPlanCommandV1: result.command,
		completedSubmitProjectPlanCommandV1: result.completed,
		errorSubmitProjectPlanCommandV1: result.error,
		invokeSubmitProjectPlanCommandV1: result.invoke,
		invokingSubmitProjectPlanCommandV1: result.invoking,
		succeedSubmitProjectPlanCommandV1: result.succeed,
		validationErrorsSubmitProjectPlanCommandV1: result.validationErrors,
		onSucceedSubmitProjectPlanCommandV1: result.onSucceed,
	}
}

export function useUnsubmitProjectPlanCommandV1(
	userId?: number | Ref<number> | (() => number), 
	workspaceId?: number | Ref<number> | (() => number), 
	portfolioId?: string | Ref<string> | (() => string), 
	projectId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
) 
{
	const _userId = isRef<number>(userId) ? userId : ref<number>((typeof userId === 'function') ? userId() : userId)
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _portfolioId = isRef<string>(portfolioId) ? portfolioId : ref<string>((typeof portfolioId === 'function') ? portfolioId() : portfolioId)
	const _projectId = isRef<string>(projectId) ? projectId : ref<string>((typeof projectId === 'function') ? projectId() : projectId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)

	const result = {
		userId: _userId,
		workspaceId: _workspaceId,
		portfolioId: _portfolioId,
		projectId: _projectId,
		id: _id,

		...useCommand(() => {
			if (typeof userId === 'function') { _userId.value = userId() }
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof portfolioId === 'function') { _portfolioId.value = portfolioId() }
			if (typeof projectId === 'function') { _projectId.value = projectId() }
			if (typeof id === 'function') { _id.value = id() }

			return new c.UnsubmitProjectPlanCommandV1(_userId.value, _workspaceId.value, _portfolioId.value, _projectId.value, _id.value)
		})
	}

	return {
		...result,
		authorizedUnsubmitProjectPlanCommandV1: result.authorized,
		unsubmitProjectPlanCommandV1: result.command,
		completedUnsubmitProjectPlanCommandV1: result.completed,
		errorUnsubmitProjectPlanCommandV1: result.error,
		invokeUnsubmitProjectPlanCommandV1: result.invoke,
		invokingUnsubmitProjectPlanCommandV1: result.invoking,
		succeedUnsubmitProjectPlanCommandV1: result.succeed,
		validationErrorsUnsubmitProjectPlanCommandV1: result.validationErrors,
		onSucceedUnsubmitProjectPlanCommandV1: result.onSucceed,
	}
}

export function useUpdateBenefitsConfidenceFactorCommandV1(
	userId?: number | Ref<number> | (() => number), 
	workspaceId?: number | Ref<number> | (() => number), 
	portfolioId?: string | Ref<string> | (() => string), 
	projectId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	benefitsConfidenceFactor?: number | null | Ref<number | null> | (() => number | null), 
) 
{
	const _userId = isRef<number>(userId) ? userId : ref<number>((typeof userId === 'function') ? userId() : userId)
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _portfolioId = isRef<string>(portfolioId) ? portfolioId : ref<string>((typeof portfolioId === 'function') ? portfolioId() : portfolioId)
	const _projectId = isRef<string>(projectId) ? projectId : ref<string>((typeof projectId === 'function') ? projectId() : projectId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _benefitsConfidenceFactor = isRef<number | null>(benefitsConfidenceFactor) ? benefitsConfidenceFactor : ref<number | null>((typeof benefitsConfidenceFactor === 'function') ? benefitsConfidenceFactor() : benefitsConfidenceFactor)

	const result = {
		userId: _userId,
		workspaceId: _workspaceId,
		portfolioId: _portfolioId,
		projectId: _projectId,
		id: _id,
		benefitsConfidenceFactor: _benefitsConfidenceFactor,

		...useCommand(() => {
			if (typeof userId === 'function') { _userId.value = userId() }
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof portfolioId === 'function') { _portfolioId.value = portfolioId() }
			if (typeof projectId === 'function') { _projectId.value = projectId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof benefitsConfidenceFactor === 'function') { _benefitsConfidenceFactor.value = benefitsConfidenceFactor() }

			return new c.UpdateBenefitsConfidenceFactorCommandV1(_userId.value, _workspaceId.value, _portfolioId.value, _projectId.value, _id.value, _benefitsConfidenceFactor.value)
		})
	}

	return {
		...result,
		authorizedUpdateBenefitsConfidenceFactorCommandV1: result.authorized,
		updateBenefitsConfidenceFactorCommandV1: result.command,
		completedUpdateBenefitsConfidenceFactorCommandV1: result.completed,
		errorUpdateBenefitsConfidenceFactorCommandV1: result.error,
		invokeUpdateBenefitsConfidenceFactorCommandV1: result.invoke,
		invokingUpdateBenefitsConfidenceFactorCommandV1: result.invoking,
		succeedUpdateBenefitsConfidenceFactorCommandV1: result.succeed,
		validationErrorsUpdateBenefitsConfidenceFactorCommandV1: result.validationErrors,
		onSucceedUpdateBenefitsConfidenceFactorCommandV1: result.onSucceed,
	}
}

export function useUpdateProjectCapexItemCommandV1(
	userId?: number | Ref<number> | (() => number), 
	workspaceId?: number | Ref<number> | (() => number), 
	portfolioId?: string | Ref<string> | (() => string), 
	projectId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	itemId?: string | Ref<string> | (() => string), 
	capexAccountId?: string | Ref<string> | (() => string), 
	name?: string | Ref<string> | (() => string), 
	cost?: number | Ref<number> | (() => number), 
	acquisitionMonthIndex?: number | Ref<number> | (() => number), 
	salvageValue?: number | null | Ref<number | null> | (() => number | null), 
	usefulLifeInYears?: number | null | Ref<number | null> | (() => number | null), 
	depreciationMethod?: any | Ref<any> | (() => any), 
	denomination?: any | Ref<any> | (() => any), 
) 
{
	const _userId = isRef<number>(userId) ? userId : ref<number>((typeof userId === 'function') ? userId() : userId)
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _portfolioId = isRef<string>(portfolioId) ? portfolioId : ref<string>((typeof portfolioId === 'function') ? portfolioId() : portfolioId)
	const _projectId = isRef<string>(projectId) ? projectId : ref<string>((typeof projectId === 'function') ? projectId() : projectId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _itemId = isRef<string>(itemId) ? itemId : ref<string>((typeof itemId === 'function') ? itemId() : itemId)
	const _capexAccountId = isRef<string>(capexAccountId) ? capexAccountId : ref<string>((typeof capexAccountId === 'function') ? capexAccountId() : capexAccountId)
	const _name = isRef<string>(name) ? name : ref<string>((typeof name === 'function') ? name() : name)
	const _cost = isRef<number>(cost) ? cost : ref<number>((typeof cost === 'function') ? cost() : cost)
	const _acquisitionMonthIndex = isRef<number>(acquisitionMonthIndex) ? acquisitionMonthIndex : ref<number>((typeof acquisitionMonthIndex === 'function') ? acquisitionMonthIndex() : acquisitionMonthIndex)
	const _salvageValue = isRef<number | null>(salvageValue) ? salvageValue : ref<number | null>((typeof salvageValue === 'function') ? salvageValue() : salvageValue)
	const _usefulLifeInYears = isRef<number | null>(usefulLifeInYears) ? usefulLifeInYears : ref<number | null>((typeof usefulLifeInYears === 'function') ? usefulLifeInYears() : usefulLifeInYears)
	const _depreciationMethod = isRef<any>(depreciationMethod) ? depreciationMethod : ref<any>((typeof depreciationMethod === 'function') ? depreciationMethod() : depreciationMethod)
	const _denomination = isRef<any>(denomination) ? denomination : ref<any>((typeof denomination === 'function') ? denomination() : denomination)

	const result = {
		userId: _userId,
		workspaceId: _workspaceId,
		portfolioId: _portfolioId,
		projectId: _projectId,
		id: _id,
		itemId: _itemId,
		capexAccountId: _capexAccountId,
		name: _name,
		cost: _cost,
		acquisitionMonthIndex: _acquisitionMonthIndex,
		salvageValue: _salvageValue,
		usefulLifeInYears: _usefulLifeInYears,
		depreciationMethod: _depreciationMethod,
		denomination: _denomination,

		...useCommand(() => {
			if (typeof userId === 'function') { _userId.value = userId() }
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof portfolioId === 'function') { _portfolioId.value = portfolioId() }
			if (typeof projectId === 'function') { _projectId.value = projectId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof itemId === 'function') { _itemId.value = itemId() }
			if (typeof capexAccountId === 'function') { _capexAccountId.value = capexAccountId() }
			if (typeof name === 'function') { _name.value = name() }
			if (typeof cost === 'function') { _cost.value = cost() }
			if (typeof acquisitionMonthIndex === 'function') { _acquisitionMonthIndex.value = acquisitionMonthIndex() }
			if (typeof salvageValue === 'function') { _salvageValue.value = salvageValue() }
			if (typeof usefulLifeInYears === 'function') { _usefulLifeInYears.value = usefulLifeInYears() }
			if (typeof depreciationMethod === 'function') { _depreciationMethod.value = depreciationMethod() }
			if (typeof denomination === 'function') { _denomination.value = denomination() }

			return new c.UpdateProjectCapexItemCommandV1(_userId.value, _workspaceId.value, _portfolioId.value, _projectId.value, _id.value, _itemId.value, _capexAccountId.value, _name.value, _cost.value, _acquisitionMonthIndex.value, _salvageValue.value, _usefulLifeInYears.value, _depreciationMethod.value, _denomination.value)
		})
	}

	return {
		...result,
		authorizedUpdateProjectCapexItemCommandV1: result.authorized,
		updateProjectCapexItemCommandV1: result.command,
		completedUpdateProjectCapexItemCommandV1: result.completed,
		errorUpdateProjectCapexItemCommandV1: result.error,
		invokeUpdateProjectCapexItemCommandV1: result.invoke,
		invokingUpdateProjectCapexItemCommandV1: result.invoking,
		succeedUpdateProjectCapexItemCommandV1: result.succeed,
		validationErrorsUpdateProjectCapexItemCommandV1: result.validationErrors,
		onSucceedUpdateProjectCapexItemCommandV1: result.onSucceed,
	}
}

export function useUpdateProjectExpenseAllocationsCommandV1(
	userId?: number | Ref<number> | (() => number), 
	workspaceId?: number | Ref<number> | (() => number), 
	portfolioId?: string | Ref<string> | (() => string), 
	projectId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	granularity?: any | null | Ref<any | null> | (() => any | null), 
	denomination?: any | Ref<any> | (() => any), 
	entries?: any | Ref<any> | (() => any), 
	comment?: string | Ref<string> | (() => string), 
) 
{
	const _userId = isRef<number>(userId) ? userId : ref<number>((typeof userId === 'function') ? userId() : userId)
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _portfolioId = isRef<string>(portfolioId) ? portfolioId : ref<string>((typeof portfolioId === 'function') ? portfolioId() : portfolioId)
	const _projectId = isRef<string>(projectId) ? projectId : ref<string>((typeof projectId === 'function') ? projectId() : projectId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _granularity = isRef<any | null>(granularity) ? granularity : ref<any | null>((typeof granularity === 'function') ? granularity() : granularity)
	const _denomination = isRef<any>(denomination) ? denomination : ref<any>((typeof denomination === 'function') ? denomination() : denomination)
	const _entries = isRef<any>(entries) ? entries : ref<any>((typeof entries === 'function') ? entries() : entries)
	const _comment = isRef<string>(comment) ? comment : ref<string>((typeof comment === 'function') ? comment() : comment)

	const result = {
		userId: _userId,
		workspaceId: _workspaceId,
		portfolioId: _portfolioId,
		projectId: _projectId,
		id: _id,
		granularity: _granularity,
		denomination: _denomination,
		entries: _entries,
		comment: _comment,

		...useCommand(() => {
			if (typeof userId === 'function') { _userId.value = userId() }
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof portfolioId === 'function') { _portfolioId.value = portfolioId() }
			if (typeof projectId === 'function') { _projectId.value = projectId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof granularity === 'function') { _granularity.value = granularity() }
			if (typeof denomination === 'function') { _denomination.value = denomination() }
			if (typeof entries === 'function') { _entries.value = entries() }
			if (typeof comment === 'function') { _comment.value = comment() }

			return new c.UpdateProjectExpenseAllocationsCommandV1(_userId.value, _workspaceId.value, _portfolioId.value, _projectId.value, _id.value, _granularity.value, _denomination.value, _entries.value, _comment.value)
		})
	}

	return {
		...result,
		authorizedUpdateProjectExpenseAllocationsCommandV1: result.authorized,
		updateProjectExpenseAllocationsCommandV1: result.command,
		completedUpdateProjectExpenseAllocationsCommandV1: result.completed,
		errorUpdateProjectExpenseAllocationsCommandV1: result.error,
		invokeUpdateProjectExpenseAllocationsCommandV1: result.invoke,
		invokingUpdateProjectExpenseAllocationsCommandV1: result.invoking,
		succeedUpdateProjectExpenseAllocationsCommandV1: result.succeed,
		validationErrorsUpdateProjectExpenseAllocationsCommandV1: result.validationErrors,
		onSucceedUpdateProjectExpenseAllocationsCommandV1: result.onSucceed,
	}
}

export function useUpdateProjectExpenseSavingsCommandV1(
	userId?: number | Ref<number> | (() => number), 
	workspaceId?: number | Ref<number> | (() => number), 
	portfolioId?: string | Ref<string> | (() => string), 
	projectId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	granularity?: any | null | Ref<any | null> | (() => any | null), 
	denomination?: any | Ref<any> | (() => any), 
	entries?: any | Ref<any> | (() => any), 
	comment?: string | Ref<string> | (() => string), 
) 
{
	const _userId = isRef<number>(userId) ? userId : ref<number>((typeof userId === 'function') ? userId() : userId)
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _portfolioId = isRef<string>(portfolioId) ? portfolioId : ref<string>((typeof portfolioId === 'function') ? portfolioId() : portfolioId)
	const _projectId = isRef<string>(projectId) ? projectId : ref<string>((typeof projectId === 'function') ? projectId() : projectId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _granularity = isRef<any | null>(granularity) ? granularity : ref<any | null>((typeof granularity === 'function') ? granularity() : granularity)
	const _denomination = isRef<any>(denomination) ? denomination : ref<any>((typeof denomination === 'function') ? denomination() : denomination)
	const _entries = isRef<any>(entries) ? entries : ref<any>((typeof entries === 'function') ? entries() : entries)
	const _comment = isRef<string>(comment) ? comment : ref<string>((typeof comment === 'function') ? comment() : comment)

	const result = {
		userId: _userId,
		workspaceId: _workspaceId,
		portfolioId: _portfolioId,
		projectId: _projectId,
		id: _id,
		granularity: _granularity,
		denomination: _denomination,
		entries: _entries,
		comment: _comment,

		...useCommand(() => {
			if (typeof userId === 'function') { _userId.value = userId() }
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof portfolioId === 'function') { _portfolioId.value = portfolioId() }
			if (typeof projectId === 'function') { _projectId.value = projectId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof granularity === 'function') { _granularity.value = granularity() }
			if (typeof denomination === 'function') { _denomination.value = denomination() }
			if (typeof entries === 'function') { _entries.value = entries() }
			if (typeof comment === 'function') { _comment.value = comment() }

			return new c.UpdateProjectExpenseSavingsCommandV1(_userId.value, _workspaceId.value, _portfolioId.value, _projectId.value, _id.value, _granularity.value, _denomination.value, _entries.value, _comment.value)
		})
	}

	return {
		...result,
		authorizedUpdateProjectExpenseSavingsCommandV1: result.authorized,
		updateProjectExpenseSavingsCommandV1: result.command,
		completedUpdateProjectExpenseSavingsCommandV1: result.completed,
		errorUpdateProjectExpenseSavingsCommandV1: result.error,
		invokeUpdateProjectExpenseSavingsCommandV1: result.invoke,
		invokingUpdateProjectExpenseSavingsCommandV1: result.invoking,
		succeedUpdateProjectExpenseSavingsCommandV1: result.succeed,
		validationErrorsUpdateProjectExpenseSavingsCommandV1: result.validationErrors,
		onSucceedUpdateProjectExpenseSavingsCommandV1: result.onSucceed,
	}
}

export function useUpdateProjectMarginsCommandV1(
	userId?: number | Ref<number> | (() => number), 
	workspaceId?: number | Ref<number> | (() => number), 
	portfolioId?: string | Ref<string> | (() => string), 
	projectId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	granularity?: any | null | Ref<any | null> | (() => any | null), 
	entries?: any | Ref<any> | (() => any), 
	comment?: string | Ref<string> | (() => string), 
) 
{
	const _userId = isRef<number>(userId) ? userId : ref<number>((typeof userId === 'function') ? userId() : userId)
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _portfolioId = isRef<string>(portfolioId) ? portfolioId : ref<string>((typeof portfolioId === 'function') ? portfolioId() : portfolioId)
	const _projectId = isRef<string>(projectId) ? projectId : ref<string>((typeof projectId === 'function') ? projectId() : projectId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _granularity = isRef<any | null>(granularity) ? granularity : ref<any | null>((typeof granularity === 'function') ? granularity() : granularity)
	const _entries = isRef<any>(entries) ? entries : ref<any>((typeof entries === 'function') ? entries() : entries)
	const _comment = isRef<string>(comment) ? comment : ref<string>((typeof comment === 'function') ? comment() : comment)

	const result = {
		userId: _userId,
		workspaceId: _workspaceId,
		portfolioId: _portfolioId,
		projectId: _projectId,
		id: _id,
		granularity: _granularity,
		entries: _entries,
		comment: _comment,

		...useCommand(() => {
			if (typeof userId === 'function') { _userId.value = userId() }
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof portfolioId === 'function') { _portfolioId.value = portfolioId() }
			if (typeof projectId === 'function') { _projectId.value = projectId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof granularity === 'function') { _granularity.value = granularity() }
			if (typeof entries === 'function') { _entries.value = entries() }
			if (typeof comment === 'function') { _comment.value = comment() }

			return new c.UpdateProjectMarginsCommandV1(_userId.value, _workspaceId.value, _portfolioId.value, _projectId.value, _id.value, _granularity.value, _entries.value, _comment.value)
		})
	}

	return {
		...result,
		authorizedUpdateProjectMarginsCommandV1: result.authorized,
		updateProjectMarginsCommandV1: result.command,
		completedUpdateProjectMarginsCommandV1: result.completed,
		errorUpdateProjectMarginsCommandV1: result.error,
		invokeUpdateProjectMarginsCommandV1: result.invoke,
		invokingUpdateProjectMarginsCommandV1: result.invoking,
		succeedUpdateProjectMarginsCommandV1: result.succeed,
		validationErrorsUpdateProjectMarginsCommandV1: result.validationErrors,
		onSucceedUpdateProjectMarginsCommandV1: result.onSucceed,
	}
}

export function useUpdateProjectPlanCommandV1(
	userId?: number | Ref<number> | (() => number), 
	workspaceId?: number | Ref<number> | (() => number), 
	portfolioId?: string | Ref<string> | (() => string), 
	projectId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	planName?: string | Ref<string> | (() => string), 
	durationInMonths?: number | Ref<number> | (() => number), 
	granularity?: any | Ref<any> | (() => any), 
	denomination?: any | Ref<any> | (() => any), 
	submissionDueDateIsoString?: string | Ref<string> | (() => string), 
) 
{
	const _userId = isRef<number>(userId) ? userId : ref<number>((typeof userId === 'function') ? userId() : userId)
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _portfolioId = isRef<string>(portfolioId) ? portfolioId : ref<string>((typeof portfolioId === 'function') ? portfolioId() : portfolioId)
	const _projectId = isRef<string>(projectId) ? projectId : ref<string>((typeof projectId === 'function') ? projectId() : projectId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _planName = isRef<string>(planName) ? planName : ref<string>((typeof planName === 'function') ? planName() : planName)
	const _durationInMonths = isRef<number>(durationInMonths) ? durationInMonths : ref<number>((typeof durationInMonths === 'function') ? durationInMonths() : durationInMonths)
	const _granularity = isRef<any>(granularity) ? granularity : ref<any>((typeof granularity === 'function') ? granularity() : granularity)
	const _denomination = isRef<any>(denomination) ? denomination : ref<any>((typeof denomination === 'function') ? denomination() : denomination)
	const _submissionDueDateIsoString = isRef<string>(submissionDueDateIsoString) ? submissionDueDateIsoString : ref<string>((typeof submissionDueDateIsoString === 'function') ? submissionDueDateIsoString() : submissionDueDateIsoString)

	const result = {
		userId: _userId,
		workspaceId: _workspaceId,
		portfolioId: _portfolioId,
		projectId: _projectId,
		id: _id,
		planName: _planName,
		durationInMonths: _durationInMonths,
		granularity: _granularity,
		denomination: _denomination,
		submissionDueDateIsoString: _submissionDueDateIsoString,

		...useCommand(() => {
			if (typeof userId === 'function') { _userId.value = userId() }
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof portfolioId === 'function') { _portfolioId.value = portfolioId() }
			if (typeof projectId === 'function') { _projectId.value = projectId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof planName === 'function') { _planName.value = planName() }
			if (typeof durationInMonths === 'function') { _durationInMonths.value = durationInMonths() }
			if (typeof granularity === 'function') { _granularity.value = granularity() }
			if (typeof denomination === 'function') { _denomination.value = denomination() }
			if (typeof submissionDueDateIsoString === 'function') { _submissionDueDateIsoString.value = submissionDueDateIsoString() }

			return new c.UpdateProjectPlanCommandV1(_userId.value, _workspaceId.value, _portfolioId.value, _projectId.value, _id.value, _planName.value, _durationInMonths.value, _granularity.value, _denomination.value, _submissionDueDateIsoString.value)
		})
	}

	return {
		...result,
		authorizedUpdateProjectPlanCommandV1: result.authorized,
		updateProjectPlanCommandV1: result.command,
		completedUpdateProjectPlanCommandV1: result.completed,
		errorUpdateProjectPlanCommandV1: result.error,
		invokeUpdateProjectPlanCommandV1: result.invoke,
		invokingUpdateProjectPlanCommandV1: result.invoking,
		succeedUpdateProjectPlanCommandV1: result.succeed,
		validationErrorsUpdateProjectPlanCommandV1: result.validationErrors,
		onSucceedUpdateProjectPlanCommandV1: result.onSucceed,
	}
}

export function useUpdateProjectResourceAllocationsCommandV1(
	userId?: number | Ref<number> | (() => number), 
	workspaceId?: number | Ref<number> | (() => number), 
	portfolioId?: string | Ref<string> | (() => string), 
	projectId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	granularity?: any | null | Ref<any | null> | (() => any | null), 
	entries?: any | Ref<any> | (() => any), 
	comment?: string | Ref<string> | (() => string), 
) 
{
	const _userId = isRef<number>(userId) ? userId : ref<number>((typeof userId === 'function') ? userId() : userId)
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _portfolioId = isRef<string>(portfolioId) ? portfolioId : ref<string>((typeof portfolioId === 'function') ? portfolioId() : portfolioId)
	const _projectId = isRef<string>(projectId) ? projectId : ref<string>((typeof projectId === 'function') ? projectId() : projectId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _granularity = isRef<any | null>(granularity) ? granularity : ref<any | null>((typeof granularity === 'function') ? granularity() : granularity)
	const _entries = isRef<any>(entries) ? entries : ref<any>((typeof entries === 'function') ? entries() : entries)
	const _comment = isRef<string>(comment) ? comment : ref<string>((typeof comment === 'function') ? comment() : comment)

	const result = {
		userId: _userId,
		workspaceId: _workspaceId,
		portfolioId: _portfolioId,
		projectId: _projectId,
		id: _id,
		granularity: _granularity,
		entries: _entries,
		comment: _comment,

		...useCommand(() => {
			if (typeof userId === 'function') { _userId.value = userId() }
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof portfolioId === 'function') { _portfolioId.value = portfolioId() }
			if (typeof projectId === 'function') { _projectId.value = projectId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof granularity === 'function') { _granularity.value = granularity() }
			if (typeof entries === 'function') { _entries.value = entries() }
			if (typeof comment === 'function') { _comment.value = comment() }

			return new c.UpdateProjectResourceAllocationsCommandV1(_userId.value, _workspaceId.value, _portfolioId.value, _projectId.value, _id.value, _granularity.value, _entries.value, _comment.value)
		})
	}

	return {
		...result,
		authorizedUpdateProjectResourceAllocationsCommandV1: result.authorized,
		updateProjectResourceAllocationsCommandV1: result.command,
		completedUpdateProjectResourceAllocationsCommandV1: result.completed,
		errorUpdateProjectResourceAllocationsCommandV1: result.error,
		invokeUpdateProjectResourceAllocationsCommandV1: result.invoke,
		invokingUpdateProjectResourceAllocationsCommandV1: result.invoking,
		succeedUpdateProjectResourceAllocationsCommandV1: result.succeed,
		validationErrorsUpdateProjectResourceAllocationsCommandV1: result.validationErrors,
		onSucceedUpdateProjectResourceAllocationsCommandV1: result.onSucceed,
	}
}

export function useUpdateProjectResourceSavingsCommandV1(
	userId?: number | Ref<number> | (() => number), 
	workspaceId?: number | Ref<number> | (() => number), 
	portfolioId?: string | Ref<string> | (() => string), 
	projectId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	granularity?: any | null | Ref<any | null> | (() => any | null), 
	entries?: any | Ref<any> | (() => any), 
	comment?: string | Ref<string> | (() => string), 
) 
{
	const _userId = isRef<number>(userId) ? userId : ref<number>((typeof userId === 'function') ? userId() : userId)
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _portfolioId = isRef<string>(portfolioId) ? portfolioId : ref<string>((typeof portfolioId === 'function') ? portfolioId() : portfolioId)
	const _projectId = isRef<string>(projectId) ? projectId : ref<string>((typeof projectId === 'function') ? projectId() : projectId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _granularity = isRef<any | null>(granularity) ? granularity : ref<any | null>((typeof granularity === 'function') ? granularity() : granularity)
	const _entries = isRef<any>(entries) ? entries : ref<any>((typeof entries === 'function') ? entries() : entries)
	const _comment = isRef<string>(comment) ? comment : ref<string>((typeof comment === 'function') ? comment() : comment)

	const result = {
		userId: _userId,
		workspaceId: _workspaceId,
		portfolioId: _portfolioId,
		projectId: _projectId,
		id: _id,
		granularity: _granularity,
		entries: _entries,
		comment: _comment,

		...useCommand(() => {
			if (typeof userId === 'function') { _userId.value = userId() }
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof portfolioId === 'function') { _portfolioId.value = portfolioId() }
			if (typeof projectId === 'function') { _projectId.value = projectId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof granularity === 'function') { _granularity.value = granularity() }
			if (typeof entries === 'function') { _entries.value = entries() }
			if (typeof comment === 'function') { _comment.value = comment() }

			return new c.UpdateProjectResourceSavingsCommandV1(_userId.value, _workspaceId.value, _portfolioId.value, _projectId.value, _id.value, _granularity.value, _entries.value, _comment.value)
		})
	}

	return {
		...result,
		authorizedUpdateProjectResourceSavingsCommandV1: result.authorized,
		updateProjectResourceSavingsCommandV1: result.command,
		completedUpdateProjectResourceSavingsCommandV1: result.completed,
		errorUpdateProjectResourceSavingsCommandV1: result.error,
		invokeUpdateProjectResourceSavingsCommandV1: result.invoke,
		invokingUpdateProjectResourceSavingsCommandV1: result.invoking,
		succeedUpdateProjectResourceSavingsCommandV1: result.succeed,
		validationErrorsUpdateProjectResourceSavingsCommandV1: result.validationErrors,
		onSucceedUpdateProjectResourceSavingsCommandV1: result.onSucceed,
	}
}

export function useUpdateProjectResourceUnitCostsCommandV1(
	userId?: number | Ref<number> | (() => number), 
	workspaceId?: number | Ref<number> | (() => number), 
	portfolioId?: string | Ref<string> | (() => string), 
	projectId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	fromYear?: number | Ref<number> | (() => number), 
	entries?: any | Ref<any> | (() => any), 
	comment?: string | Ref<string> | (() => string), 
) 
{
	const _userId = isRef<number>(userId) ? userId : ref<number>((typeof userId === 'function') ? userId() : userId)
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _portfolioId = isRef<string>(portfolioId) ? portfolioId : ref<string>((typeof portfolioId === 'function') ? portfolioId() : portfolioId)
	const _projectId = isRef<string>(projectId) ? projectId : ref<string>((typeof projectId === 'function') ? projectId() : projectId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _fromYear = isRef<number>(fromYear) ? fromYear : ref<number>((typeof fromYear === 'function') ? fromYear() : fromYear)
	const _entries = isRef<any>(entries) ? entries : ref<any>((typeof entries === 'function') ? entries() : entries)
	const _comment = isRef<string>(comment) ? comment : ref<string>((typeof comment === 'function') ? comment() : comment)

	const result = {
		userId: _userId,
		workspaceId: _workspaceId,
		portfolioId: _portfolioId,
		projectId: _projectId,
		id: _id,
		fromYear: _fromYear,
		entries: _entries,
		comment: _comment,

		...useCommand(() => {
			if (typeof userId === 'function') { _userId.value = userId() }
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof portfolioId === 'function') { _portfolioId.value = portfolioId() }
			if (typeof projectId === 'function') { _projectId.value = projectId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof fromYear === 'function') { _fromYear.value = fromYear() }
			if (typeof entries === 'function') { _entries.value = entries() }
			if (typeof comment === 'function') { _comment.value = comment() }

			return new c.UpdateProjectResourceUnitCostsCommandV1(_userId.value, _workspaceId.value, _portfolioId.value, _projectId.value, _id.value, _fromYear.value, _entries.value, _comment.value)
		})
	}

	return {
		...result,
		authorizedUpdateProjectResourceUnitCostsCommandV1: result.authorized,
		updateProjectResourceUnitCostsCommandV1: result.command,
		completedUpdateProjectResourceUnitCostsCommandV1: result.completed,
		errorUpdateProjectResourceUnitCostsCommandV1: result.error,
		invokeUpdateProjectResourceUnitCostsCommandV1: result.invoke,
		invokingUpdateProjectResourceUnitCostsCommandV1: result.invoking,
		succeedUpdateProjectResourceUnitCostsCommandV1: result.succeed,
		validationErrorsUpdateProjectResourceUnitCostsCommandV1: result.validationErrors,
		onSucceedUpdateProjectResourceUnitCostsCommandV1: result.onSucceed,
	}
}

export function useUpdateProjectRevenuesCommandV1(
	userId?: number | Ref<number> | (() => number), 
	workspaceId?: number | Ref<number> | (() => number), 
	portfolioId?: string | Ref<string> | (() => string), 
	projectId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	granularity?: any | null | Ref<any | null> | (() => any | null), 
	denomination?: any | Ref<any> | (() => any), 
	entries?: any | Ref<any> | (() => any), 
	comment?: string | Ref<string> | (() => string), 
) 
{
	const _userId = isRef<number>(userId) ? userId : ref<number>((typeof userId === 'function') ? userId() : userId)
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _portfolioId = isRef<string>(portfolioId) ? portfolioId : ref<string>((typeof portfolioId === 'function') ? portfolioId() : portfolioId)
	const _projectId = isRef<string>(projectId) ? projectId : ref<string>((typeof projectId === 'function') ? projectId() : projectId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _granularity = isRef<any | null>(granularity) ? granularity : ref<any | null>((typeof granularity === 'function') ? granularity() : granularity)
	const _denomination = isRef<any>(denomination) ? denomination : ref<any>((typeof denomination === 'function') ? denomination() : denomination)
	const _entries = isRef<any>(entries) ? entries : ref<any>((typeof entries === 'function') ? entries() : entries)
	const _comment = isRef<string>(comment) ? comment : ref<string>((typeof comment === 'function') ? comment() : comment)

	const result = {
		userId: _userId,
		workspaceId: _workspaceId,
		portfolioId: _portfolioId,
		projectId: _projectId,
		id: _id,
		granularity: _granularity,
		denomination: _denomination,
		entries: _entries,
		comment: _comment,

		...useCommand(() => {
			if (typeof userId === 'function') { _userId.value = userId() }
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof portfolioId === 'function') { _portfolioId.value = portfolioId() }
			if (typeof projectId === 'function') { _projectId.value = projectId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof granularity === 'function') { _granularity.value = granularity() }
			if (typeof denomination === 'function') { _denomination.value = denomination() }
			if (typeof entries === 'function') { _entries.value = entries() }
			if (typeof comment === 'function') { _comment.value = comment() }

			return new c.UpdateProjectRevenuesCommandV1(_userId.value, _workspaceId.value, _portfolioId.value, _projectId.value, _id.value, _granularity.value, _denomination.value, _entries.value, _comment.value)
		})
	}

	return {
		...result,
		authorizedUpdateProjectRevenuesCommandV1: result.authorized,
		updateProjectRevenuesCommandV1: result.command,
		completedUpdateProjectRevenuesCommandV1: result.completed,
		errorUpdateProjectRevenuesCommandV1: result.error,
		invokeUpdateProjectRevenuesCommandV1: result.invoke,
		invokingUpdateProjectRevenuesCommandV1: result.invoking,
		succeedUpdateProjectRevenuesCommandV1: result.succeed,
		validationErrorsUpdateProjectRevenuesCommandV1: result.validationErrors,
		onSucceedUpdateProjectRevenuesCommandV1: result.onSucceed,
	}
}

